"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const audiences = [{
  title: "Destination Curation",
  description: "Explore ultra-exclusive sanctuaries curated for the discerning LGBTQ+ traveler. From Mykonos to Bangkok, we secure seamless access to the extraordinary.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/luxury_destination_curation.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/luxury_destination_curation.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/luxury_destination_curation.png-wvc-sizes",
    alt: "Aerial view of a minimalist seaside luxury resort"
  },
  link: "/ExperiencesPage"
}, {
  title: "Bespoke Concierge",
  description: "A dedicated, one-on-one custom itinerary service. We transform your travel visions into flawless journeys crafted with utmost discretion and sophistication.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/bespoke_concierge_service.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/bespoke_concierge_service.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/bespoke_concierge_service.png-wvc-sizes",
    alt: "Interior of an upscale boutique hotel lounge"
  },
  link: "/ContactUsPage"
}];
export default function BeginYourJourney() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="251648" id="begin-your-journey" className="dark bg-background py-24 lg:py-32" ref={sectionRef}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className={`grid grid-cols-1 gap-8 md:grid-cols-2 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {audiences.map((audience, index) => <div data-index={index} key={index} className="h-full">
              <Link to={audience.link} className="group block h-full">
                <Card className="h-full overflow-hidden rounded-md border-border bg-card transition-transform duration-500 ease-out hover:scale-[1.02] hover:shadow-xl">
                  <div className="relative aspect-[4/3] w-full overflow-hidden bg-muted">
                    <img src={audience.image.src} data-wvc-srcset={audience.image.srcset} data-wvc-sizes={audience.image.sizes} alt={audience.image.alt} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                    {}
                    <div className="absolute inset-0 bg-primary/10 transition-opacity duration-500 group-hover:opacity-0" />
                  </div>
                  
                  <CardHeader className="pt-8 pb-4">
                    <CardTitle className="font-default text-2xl font-light tracking-wider text-foreground">
                      {audience.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="pb-8">
                    <CardDescription className="font-default text-base leading-relaxed text-muted-foreground tracking-wide">
                      {audience.description}
                    </CardDescription>
                    
                    <div className="mt-6 flex items-center text-sm font-semibold uppercase tracking-widest text-primary transition-colors group-hover:text-primary/80">
                      Discover More
                      <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </div>)}
        </div>

        <div className={`mt-20 flex justify-center transition-all delay-300 duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <Button asChild size="lg" className="h-14 rounded-md bg-primary px-10 font-default text-sm font-semibold uppercase tracking-widest text-primary-foreground shadow-lg transition-all hover:bg-primary/90 hover:shadow-xl">
            <Link to="/ContactUsPage">
              Begin Your Journey
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}